<template>
	<b-modal
		ref="diffTablesModal"
		id="diff-tables-dialog"
		:modal-class="theme"
		hide-footer
		centered
		body-class="modal__confirm"
		size="lg"
	>
		<DiffTables :diffGroup="diffGroup" :name="name"/>
	</b-modal>
</template>

<script>
import DiffTables from './DiffTables';
import ThemeService from '../../services/theme';

export default {
	name: "DiffTablesDialog",
	components: {
		DiffTables
	},
	data() {
		return {
			diffGroup: [],
			title: ""
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show(diffObj) {
			this.diffGroup = diffObj.diffGroup;
			this.title = diffObj.title;
			this.$refs.diffTablesModal.show();
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	}
};
</script>
